import React, { useEffect, useState } from 'react'
import '../assets/styles/modal.scss'
import { useTranslation } from 'react-i18next';
import closeIcon from '../images/icons/Icon2.png'
import useSidebarHidden from '../common/useSidebarHidden';

export const DeleteConf = (props) => {
  const { t } = useTranslation();
  const [isError, setIsError] = useState(false)
  const [updateStatusText, setUpdateStatusText] = useState("")
 const sideBarHidden = useSidebarHidden('.content-container');
   useEffect(() => {
    if (props.modalFormStatusObj) {
      if (('text' in props.modalFormStatusObj)) {
        setUpdateStatusText(props.modalFormStatusObj.text);
      }
      else if (('error' in props.modalFormStatusObj)) {
        setUpdateStatusText(props.modalFormStatusObj.error);
        setIsError(props.modalFormStatusObj.error)
      }
    };
   }, [props.modalFormStatusObj])

  const onClickDelete=()=>{
    props.onCloseDelete()
    removeContainerOverlay()
  }

  const removeContainerOverlay = () => {
    /**
     * Remove overlay to parent class
     */
    (document.querySelectorAll('.content-container')[0]).classList.remove('modal-overlay-bg2');
  };

  return (
    <div className="overlay" role="dialog">
          <div className={`${ sideBarHidden ? 'dialog-fs2' : 'dialog'} sm-scrollbar`}>
        <div className="dialog__content">
        <button className='flexRow justifyContentFlexEnd width100' onClick={onClickDelete}>
                          <img src={closeIcon} alt="close" data-icon='close'/>
                      </button>
          <div className="dialog__body_container font-weight-margin flexCol alignItemsCenter justifyContentCenter flexWrap">
            <div>{props.description}</div>
          </div>
          {updateStatusText &&
            <div className={"dialog__statusBlock " + (isError ? 'alert_error' : 'alert_success')}>
              {updateStatusText}
            </div>}
        </div>
        <div className="dialog__footer flexRow justifyContentSpaceEvenly margBottm20">
          <button disabled={props.buttonStat?props.buttonStat:false} className={"continue-button" + (props.state && props.state.deleteProg ? ' button_inrt' : '')} onClick={props.onContinue}>{t('buttons.continue')}</button>
        </div>
      </div>
    </div>
  );
}
